import React, { useState, useEffect } from 'react';
import { Trash2 } from 'lucide-react';
import { deleteImage } from './firebase';

const App = () => {
  const [images, setImages] = useState([]);
  const [error, setError] = useState(null);
  const [password, setPassword] = useState('');
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    fetchImages();
  }, []);

  const fetchImages = async () => {
    try {
      const response = await fetch('https://new-nub-server-production.up.railway.app/memeslist');
      const data = await response.json();
      console.log(data);
      setImages(data);
    } catch (error) {
      setError('Error fetching images: ' + error.message);
    }
  };

  const handlePasswordSubmit = (e) => {
    e.preventDefault();
    // Replace 'your_secret_password' with the actual password you want to use
    if (password === '5556555') {
      setIsAuthenticated(true);
      fetchImages();
    } else {
      setError('Incorrect password');
    }
  };

  const handleDeleteClick = async (imageId) => {
    if (window.confirm('Are you sure you want to delete this image?')) {
      try {
        await deleteImage(imageId);
        // Remove the deleted image from the state
        setImages(images.filter(image => image.id !== imageId));
      } catch (error) {
        setError('Error deleting image: ' + error.message);
      }
    }
  };

  if (!isAuthenticated) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <form onSubmit={handlePasswordSubmit}>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Enter password"
            style={{ marginRight: '8px', padding: '8px' }}
          />
          <button type="submit" style={{ padding: '8px 16px', backgroundColor: '#4CAF50', color: 'white', border: 'none', cursor: 'pointer' }}>
            Submit
          </button>
          {error && <div style={{ color: 'red', marginTop: '8px' }}>{error}</div>}
        </form>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{
        padding: '16px',
        borderRadius: '4px',
        backgroundColor: '#fecaca',
        color: '#7f1d1d',
        border: '1px solid #f87171',
        marginBottom: '16px'
      }}>
        {error}
      </div>
    );
  }

  return (
    <>
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: '20px',
        fontWeight: 'bold',
        marginBottom: '16px'
      }}>{images.length} total AI Nub Memes.</div>

      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))',
        gap: '16px',
        padding: '16px'
      }}>
        {images.map((image) => (
          <div key={image.id} style={{ position: 'relative' }}>
            <img
              src={image.source}
              alt={image.title || 'Image'}
              style={{
                width: '100%',
                height: '250px',
                objectFit: 'cover',
                borderRadius: '8px'
              }}
            />
            <button
              onClick={() => handleDeleteClick(image.id)}
              style={{
                position: 'absolute',
                top: '8px',
                right: '8px',
                backgroundColor: 'rgba(239, 68, 68, 0.8)',
                color: 'white',
                border: 'none',
                borderRadius: '50%',
                padding: '8px',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Trash2 size={20} />
            </button>
          </div>
        ))}
      </div>
    </>
  );
};

export default App;